"use strict";

exports.__esModule = true;
exports.useConstructor = void 0;
var _react = require("react");
/**
 * useConstructor
 * Simulate the constructor class functionality
 * @param {Function} callback
 * @returns {void}
 */
var useConstructor = function useConstructor(callback) {
  if (callback === void 0) {
    callback = function callback() {};
  }
  var hasBeenCalled = (0, _react.useRef)(false);
  if (hasBeenCalled.current) return;
  callback();
  hasBeenCalled.current = true;
};
exports.useConstructor = useConstructor;